var React = require('react');
var css = require('./module.scss');
var Input = require('../input/index');
var InputGroup = require('../input/group');
var Select = require('../select/index');
var Datepicker = require('../datepicker/index');
var DatepickerGroup = require('../datepicker/group');
var Row = require('../grid/row.js');
var Col = require('../grid/col.js');
var areaResetIcon = require('./reset-icon.png');
var SelectMultiple = require('../selectMultiple/index');

var types = [
    'Datepicker',
    'Select',
    'TextInput',
    'DivNode',
    'SelectMultiple'
];

var defaultLabelSpan = 8;

var FormItem = React.createClass({

    inArray: function(val, arr) {
        for (var i = 0, len = arr.length; i < len; i++) {
            if (val.toString() == arr[i].toString()) {
                return true;
            }
        }
        return false;
    },

    renderLabel: function() {
        if(!this.props.data.label || this.props.data.isHide == 'hidden') {
            return null;
        }

        return (
            <label
                className='fp-control-label'
                htmlFor={this.props.data.name}
            >
                {this.props.data.label}
            </label>
        );
    },

    renderTextInput: function() {
        var data = this.props.data;
        data.labelSpan = data.labelSpan !== undefined ? data.labelSpan : defaultLabelSpan;
        if (data.more) {
            return (
                <Row className={data.className}>
                    <Col span={data.labelSpan} className='fp-query-label-col'>
                        {this.renderLabel()}
                    </Col>
                    <Col span={24 - data.labelSpan}>
                        <InputGroup
                            name={data.name}
                            value={data.value || ""}
                            more={data.more}
                            moreValue={data.moreValue}
                            placeholder={data.placeholder}
                            options={data.options}
                            size={data.size}
                            wtype={data.wtype}
                            dateFmt={data.dateFmt}
                            onChange={data.onChange}
                            onMoreChange={data.onMoreChange}
                            dataType={data.dataType}
                            moreDataType={data.moreDataType}
                        />
                    </Col>
                </Row>
            );
        }
        return (
            <Row className={data.className}>
                <Col span={data.labelSpan} className='fp-query-label-col'>
                    {this.renderLabel()}
                </Col>
                <Col span={24 - data.labelSpan}>
                    <Input
                        className='fp-query-input'
                        name={data.name}
                        value={data.value || ""}
                        disabled={data.disabled}
                        readonly={data.readonly}
                        onFocus={data.onFocus}
                        onBlur={data.onBlur}
                        onKeyDown={data.onKeyDown}
                        onKeyPress={data.onKeyPress}
                        onInput={data.onInput}
                        onKeyUp={data.onKeyUp}
                        onChange={data.onChange}
                        placeholder={data.placeholder}
                        size={data.size}
                        wtype={data.wtype}
                        dataType={data.dataType}
                        type={data.isHide}
                    />
                </Col>
            </Row>
        );
    },

    renderDivNode: function() {
        var data = this.props.data;
        data.labelSpan = data.labelSpan !== undefined ? data.labelSpan : defaultLabelSpan;
        return <Row className={data.className}>
            <Col span={data.labelSpan} className='fp-query-label-col '>
                {this.renderLabel()}
            </Col>
            <Col span={24 - data.labelSpan} className='area-input'>
                <div className='fp-query-div-node' onClick={data.onClick}>
                    {data.value}
                </div>
                {
                    (data.value !== undefined && data.value !== '' && data.reset !== undefined) ? <img src={areaResetIcon} className="area-reset" onClick={data.reset}/> : null
                }
            </Col>
        </Row>;
    },

    renderSelect: function() {
        var data = this.props.data;
        data.labelSpan = data.labelSpan !== undefined ? data.labelSpan : defaultLabelSpan;
        return (
            <Row className={data.className}>
                <Col span={data.labelSpan} className='fp-query-label-col'>
                    {this.renderLabel()}
                </Col>
                <Col span={24 - data.labelSpan}>
                    <Select
                        className='fp-query-select'
                        name={data.name}
                        value={data.value}
                        options={data.options}
                        onChange={data.onChange}
                        onFocus={data.onFocus}
                        onBlur={data.onBlur}
                        disabled={data.disabled}
                        placeholder={data.placeholder}
                        readonly={data.readonly}
                        size={data.size}
                        wtype={data.wtype}
                        keyMap={data.keyMap}
                        filterable={data.filterable}
                        type={data.isHide}
                    />
                </Col>
            </Row>
        );
    },
    renderSelectMultiple: function() {
        var data = this.props.data;
        data.labelSpan = data.labelSpan !== undefined ? data.labelSpan : defaultLabelSpan;
        return (
            <Row className={data.className}>
                <Col span={data.labelSpan} className='fp-query-label-col'>
                    {this.renderLabel()}
                </Col>
                <Col span={24 - data.labelSpan}>
                    <SelectMultiple
                        className='fp-query-select'
                        name={data.name}
                        value={data.value}
                        options={data.options}
                        onChange={data.onChange}
                        onFocus={data.onFocus}
                        onBlur={data.onBlur}
                        disabled={data.disabled}
                        placeholder={data.placeholder}
                        readonly={data.readonly}
                        size={data.size}
                        wtype={data.wtype}
                        keyMap={data.keyMap}
                        filterable={data.filterable}
                        type={data.isHide}
                    />
                </Col>
            </Row>
        );
    },

    renderDatepicker: function() {
        var data = this.props.data;
        data.labelSpan = data.labelSpan !== undefined ? data.labelSpan : defaultLabelSpan;
        if(data.more) {
            return (
                <Row className={data.className}>
                    <Col span={data.labelSpan} className='fp-query-label-col'>
                        {this.renderLabel()}
                    </Col>
                    <Col span={24 - data.labelSpan}>
                        <DatepickerGroup
                            name={data.name}
                            value={data.value}
                            more={data.more}
                            moreValue={data.moreValue}
                            onChange={data.onChange}
                            onMoreChange={data.onMoreChange}
                            placeholder={data.placeholder}
                            options={data.options}
                            size={data.size}
                            wtype={data.wtype}
                            dateFmt={data.dateFmt}
                            minDate={data.minDate}
                            maxDate={data.maxDate}
                            moreMinDate={data.moreMinDate}
                            moreMaxDate={data.moreMaxDate}
                        />
                    </Col>
                </Row>
            );
        }

        return (
            <Row className={data.className}>
                <Col span={data.labelSpan} className='fp-query-label-col'>
                    {this.renderLabel()}
                </Col>
                <Col span={24 - data.labelSpan}>
                    <Datepicker
                        className='fp-query-datepicker'
                        name={data.name}
                        value={data.value}
                        onChange={data.onChange}
                        placeholder={data.placeholder}
                        size={data.size}
                        wtype={data.wtype}
                        dateFmt={data.dateFmt}
                        minDate={data.minDate}
                        maxDate={data.maxDate}
                    />
                </Col>
            </Row>
        );
    },

    render: function() {
        if (!this.props.data || !this.props.data.type
            || !this.inArray(this.props.data.type, types)) {
            return null;
        }
        return this['render' + this.props.data.type]();
    }

});

module.exports = FormItem;




// WEBPACK FOOTER //
// ./component/queryform/formItem.js